import { usePermissions } from "components/context/permissionsContext";

export const useEmployeePermission = () => {
  const { userPermissions } = usePermissions();

  const hasEmployeeSavePermission = userPermissions.some(
    (item) =>
      item.module === "Employee" &&
      item.controller === "Employee" &&
      item.identifier === "employee-save" &&
      item.hasPermission
  );
  const hasEmployeeGetPermission = userPermissions.some(
    (item) =>
      item.module === "Employee" &&
      item.controller === "Employee" &&
      item.identifier === "employee-get" &&
      item.hasPermission
  );
  const hasEmployeeDeletePermission = userPermissions.some(
    (item) =>
      item.module === "Employee" &&
      item.controller === "Employee" &&
      item.identifier === "employee-delete" &&
      item.hasPermission
  );
  const hasEmployeeGetDepartmentsPermission = userPermissions.some(
    (item) =>
      item.module === "Employee" &&
      item.controller === "Employee" &&
      item.identifier === "employee-getdeparments" &&
      item.hasPermission
  );
  const hasEmployeeUpdatePersonalDetailPermission = userPermissions.some(
    (item) =>
      item.module === "Employee" &&
      item.controller === "Employee" &&
      item.identifier === "employee-updatepersonaldetail" &&
      item.hasPermission
  );
  const hasEmployeeSearchPermission = userPermissions.some(
    (item) =>
      item.module === "Employee" &&
      item.controller === "Employee" &&
      item.identifier === "employee-search" &&
      item.hasPermission
  );

  const EmployeePermissionProps = {
    hasEmployeeSavePermission,
    hasEmployeeGetPermission,
    hasEmployeeDeletePermission,
    hasEmployeeGetDepartmentsPermission,
    hasEmployeeUpdatePersonalDetailPermission,
    hasEmployeeSearchPermission,
  };

  return {
    EmployeePermissionProps,
  };
};
